const RIOBLAST_TAGS = {
  OPERATIONS: 'OPERATIONS',
  OPERATION_OVERVIEW: 'OPERATION_OVERVIEW',
  OPERATION_OVERVIEW_FROZEN: 'OPERATION_OVERVIEW_FROZEN',
  OPERATION_ATTACHMENTS: 'OPERATION_ATTACHMENTS',
  OPERATION_ATTACHMENT_SIGNED_URL: 'OPERATION_ATTACHMENT_SIGNED_URL',
  OPERATION_STATE_HISTORY_PROGRESS: 'OPERATION_STATE_HISTORY_PROGRESS',
  OPERATION_INVOICES: 'OPERATION_INVOICES',
  OPERATION_HISTORY: 'OPERATION_HISTORY',
  OPERATION_COUNT: 'OPERATION_COUNT',
  DEBTOR_CONTACTS: 'DEBTOR_CONTACTS',
} as const;

type RioblastTag = (typeof RIOBLAST_TAGS)[keyof typeof RIOBLAST_TAGS];

const ALL_TAGS: RioblastTag[] = [
  RIOBLAST_TAGS.OPERATIONS,
  RIOBLAST_TAGS.OPERATION_OVERVIEW,
  RIOBLAST_TAGS.OPERATION_OVERVIEW_FROZEN,
  RIOBLAST_TAGS.OPERATION_ATTACHMENTS,
  RIOBLAST_TAGS.OPERATION_ATTACHMENT_SIGNED_URL,
  RIOBLAST_TAGS.OPERATION_STATE_HISTORY_PROGRESS,
  RIOBLAST_TAGS.OPERATION_INVOICES,
  RIOBLAST_TAGS.OPERATION_HISTORY,
  RIOBLAST_TAGS.OPERATION_COUNT,
  RIOBLAST_TAGS.DEBTOR_CONTACTS,
] as const;

export { ALL_TAGS, RIOBLAST_TAGS };
